// ./client/src/context/announcement/announcementReducer.js

const announcementReducer = (state, { type, payload }) => {
    switch (type) {
        // ============================================================================
        // ANNOUNCEMENT MANAGEMENT
        // ============================================================================
        case 'SEND_ANNOUNCEMENT_REQUEST':
            return {
                ...state,
                isLoading: true,
                error: null,
                success: null
            };

        case 'SEND_ANNOUNCEMENT_SUCCESS':
            return {
                ...state,
                isLoading: false,
                success: 'Announcement sent successfully',
                error: null,
                announcements: [payload.announcement, ...state.announcements],
                totalRecipients: payload.totalStudents,
                sentCount: payload.successCount
            };

        case 'SEND_ANNOUNCEMENT_FAILURE':
            return {
                ...state,
                isLoading: false,
                error: payload,
                success: null
            };

        // ✅ NEW: Admin announcement actions
        case 'SEND_ADMIN_ANNOUNCEMENT_REQUEST':
            return {
                ...state,
                isLoading: true,
                error: null,
                success: null
            };

        case 'SEND_ADMIN_ANNOUNCEMENT_SUCCESS':
            return {
                ...state,
                isLoading: false,
                lastSentAnnouncement: payload,
                totalRecipients: payload.totalUsers || 0,
                sentCount: payload.sentCount || 0,
                success: 'Admin announcement sent successfully'
            };

        case 'SEND_ADMIN_ANNOUNCEMENT_FAILURE':
            return {
                ...state,
                isLoading: false,
                error: payload,
                success: null
            };

        // ============================================================================
        // ANNOUNCEMENT HISTORY
        // ============================================================================
        case 'GET_ANNOUNCEMENT_HISTORY_REQUEST':
            return {
                ...state,
                isLoading: true,
                error: null
            };

        case 'GET_ANNOUNCEMENT_HISTORY_SUCCESS':
            return {
                ...state,
                isLoading: false,
                announcementHistory: payload.announcements,
                totalAnnouncements: payload.total,
                currentPage: payload.page,
                totalPages: payload.totalPages,
                error: null
            };

        case 'GET_ANNOUNCEMENT_HISTORY_FAILURE':
            return {
                ...state,
                isLoading: false,
                error: payload
            };

        // ✅ NEW: Admin announcement history
        case 'GET_ADMIN_ANNOUNCEMENT_HISTORY_REQUEST':
            return {
                ...state,
                isLoading: true,
                error: null
            };

        case 'GET_ADMIN_ANNOUNCEMENT_HISTORY_SUCCESS':
            return {
                ...state,
                isLoading: false,
                adminAnnouncements: payload.announcements || [],
                totalAnnouncements: payload.total || 0,
                currentPage: payload.page || 1,
                totalPages: payload.totalPages || 1
            };

        case 'GET_ADMIN_ANNOUNCEMENT_HISTORY_FAILURE':
            return {
                ...state,
                isLoading: false,
                error: payload
            };

        // ============================================================================
        // STUDENT ANNOUNCEMENTS
        // ============================================================================
        case 'GET_STUDENT_ANNOUNCEMENTS_REQUEST':
            return {
                ...state,
                isLoading: true,
                error: null
            };

        case 'GET_STUDENT_ANNOUNCEMENTS_SUCCESS':
            return {
                ...state,
                isLoading: false,
                studentAnnouncements: payload.announcements,
                totalAnnouncements: payload.total,
                currentPage: payload.page,
                totalPages: payload.totalPages,
                unreadCount: payload.announcements.filter(a => !a.read).length,
                error: null
            };

        case 'GET_STUDENT_ANNOUNCEMENTS_FAILURE':
            return {
                ...state,
                isLoading: false,
                error: payload
            };

        // ============================================================================
        // MARK AS READ
        // ============================================================================
        case 'MARK_ANNOUNCEMENT_AS_READ_REQUEST':
            return {
                ...state,
                isLoading: true,
                error: null
            };

        case 'MARK_ANNOUNCEMENT_AS_READ_SUCCESS':
            return {
                ...state,
                isLoading: false,
                studentAnnouncements: state.studentAnnouncements.map(a =>
                    a.id === payload.announcementId
                        ? { ...a, read: true, readAt: new Date() }
                        : a
                ),
                unreadCount: Math.max(0, state.unreadCount - 1),
                error: null
            };

        case 'MARK_ANNOUNCEMENT_AS_READ_FAILURE':
            return {
                ...state,
                isLoading: false,
                error: payload
            };

        // ============================================================================
        // DELETE ANNOUNCEMENT
        // ============================================================================
        case 'DELETE_ANNOUNCEMENT_REQUEST':
            return {
                ...state,
                isLoading: true,
                error: null
            };

        case 'DELETE_ANNOUNCEMENT_SUCCESS':
            return {
                ...state,
                isLoading: false,
                announcementHistory: state.announcementHistory.filter(
                    a => a.id !== payload.announcementId
                ),
                success: 'Announcement deleted successfully',
                error: null
            };

        case 'DELETE_ANNOUNCEMENT_FAILURE':
            return {
                ...state,
                isLoading: false,
                error: payload
            };

        // ============================================================================
        // CURRENT ANNOUNCEMENT
        // ============================================================================
        case 'SET_CURRENT_ANNOUNCEMENT':
            return {
                ...state,
                currentAnnouncement: payload,
                error: null
            };

        case 'CLEAR_CURRENT_ANNOUNCEMENT':
            return {
                ...state,
                currentAnnouncement: null,
                error: null
            };

        // ============================================================================
        // UI STATE
        // ============================================================================
        case 'SET_LOADING':
            return {
                ...state,
                isLoading: payload
            };

        case 'SET_ERROR':
            return {
                ...state,
                error: payload,
                isLoading: false
            };

        case 'CLEAR_ERROR':
            return {
                ...state,
                error: null
            };

        case 'CLEAR_SUCCESS':
            return {
                ...state,
                success: null
            };

        case 'RESET_ANNOUNCEMENT_STATE':
            return {
                announcements: [],
                studentAnnouncements: [],
                currentAnnouncement: null,
                announcementHistory: [],
                currentPage: 1,
                totalPages: 1,
                totalAnnouncements: 0,
                totalRecipients: 0,
                sentCount: 0,
                readCount: 0,
                unreadCount: 0,
                isLoading: false,
                error: null,
                success: null
            };

        default:
            return state;
    }
};

export default announcementReducer;